import { PaymentProviderKey } from "kz-ui-sdk";

const PROVIDER_IMAGE_MAP: Partial<Record<PaymentProviderKey, string | null>> = {
  [PaymentProviderKey.Mint]: "/images/mint-logo.png",
};

const BANK_TRANSFER_IMAGE = "/images/bank-transfer-logo.png";
